import { render, staticRenderFns } from "./NavigationMarket.vue?vue&type=template&id=fa2f5e0a&scoped=true"
import script from "./NavigationMarket.vue?vue&type=script&lang=js"
export * from "./NavigationMarket.vue?vue&type=script&lang=js"
import style0 from "./NavigationMarket.vue?vue&type=style&index=0&id=fa2f5e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2f5e0a",
  null
  
)

export default component.exports